import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import type { TranslateLoader, TranslationObject } from '@ngx-translate/core';

/**
 * Cargador de traducciones que va por `fetch`, no por `HttpClient`.
 *
 * El loader HTTP de ngx-translate usa `HttpClient`, así que su petición pasa por
 * la cadena de interceptores de la app. El `authInterceptor` intenta adjuntar un
 * token y, cuando no hay sesión utilizable, corta la petición con un 401
 * sintético: el fichero de traducción no llegaba a pedirse y la interfaz se
 * quedaba pintando las claves en crudo (`auth.login.tagline`).
 *
 * Los ficheros de `assets/i18n` son estáticos y públicos —los sirve el mismo
 * nginx que la aplicación—, así que no necesitan token ni interceptor. Con
 * `fetch` se saltan la cadena entera y cargan siempre, haya sesión o no.
 */
@Injectable()
export class FetchTranslateLoader implements TranslateLoader {
  private readonly prefix = '/assets/i18n/';
  private readonly suffix = '.json';

  getTranslation(lang: string): Observable<TranslationObject> {
    const url = `${this.prefix}${lang}${this.suffix}`;
    return from(
      fetch(url, { credentials: 'same-origin' }).then(res => {
        if (!res.ok) {
          throw new Error(`No se pudo cargar ${url}: HTTP ${res.status}`);
        }
        return res.json();
      }),
    ).pipe(map(data => data as TranslationObject));
  }
}
